//deps
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import React, { useEffect } from "react";
import { applyMiddleware } from "redux";

//views
import AsignReports from "./AssignReports";
import ViewReportsAssigments from "./ViewReportsAssigments";

//reducer
import { reportAssignment as reducer } from "../../reducers/reports-assignment";

//actions
import { getPhysicians, getItervals } from "../../actions/reports-assignment";

//style
import "./index.css";
import { legacy_createStore as createStore } from "redux";
import { setTitle } from "app/store/transmission/slice/transmissionSlice";
import { useDispatch } from "react-redux";

const store = createStore(reducer, applyMiddleware(thunk));

export function ReportsAssigment(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    // fill the redux store
    store.dispatch(getPhysicians());
    store.dispatch(getItervals());
    dispatch(setTitle({ title: "Report Assignments" }));
  }, [dispatch]);

  return (
    <>
      <Provider store={store}>
        <AsignReports title="Assign Reports" />
        <ViewReportsAssigments title="Reports Assignments" />
      </Provider>
    </>
  );
}
